import React from 'react';
import { LIMITED_READ } from '../../../constants/AccountCapability';
import CompositeCalloutComponent from './CompositeCalloutComponent';

/**
 * The account must be readable and be a savings product in order to render AER info.
 *
 * @todo The account readability check and type check may be best suited
 * for the parent component to perform in order to avoid mounting a null-rendering component
 * for non-savings products unnecessarily. For now, we copy what was in getAERInfo()
 *
 * @todo Reg saver product 632 does not currently return an interest rate in the account response.
 * Needs confirmed if expected for this product or data setup issue. GD.
 * @returns
 */
export const AERInformation = ({ account }) => {
  if (!account.actionsAvailable[LIMITED_READ] && account.type === 'savings') {
    let interest;
    let interestInformation;

    if (account.accountDetails?.error || !account.accountDetails) {
      interest =
        'Sorry savings interest rate is unavailable right now. Please try again later.';
      interestInformation = '';
    } else if (typeof account.accountDetails.interest_rate === 'number') {
      if (account.product.code === '760') {
        interest = `10.38% AER. Pay in up to £250 per month. Conditions apply.`;
        interestInformation = `${account.accountDetails.interest_rate}% Gross on deposits up to £250 per month. Check our website for more detail on interest rates for all our Savings accounts`;
      } else if (account.product.code === '632') {
        interest = `${account.accountDetails.interest_rate}% AER. Pay in up to £250 per month.`;
        interestInformation =
          'Pay in up to £250 each calendar month and earn interest on this. Check our website for more detail on interest rates for all our savings accounts.';
      } else {
        interest = `Savings interest rate ${account.accountDetails.interest_rate}% AER (Annual Equivalent Rate).`;
        interestInformation =
          'The Annual Equivalent Rate illustrates what the interest rate would be if interest was paid and compounded once each year.';
      }
    }
    /**
     * Regular Saver Exclusive (IM760) behaves differently from other savings accounts.
     * We use different copy in the interestInformation dropdown.
     * Otherwise, we use the standard `interestInformation` copy in the `else` block.
     * `interestInformation` should *always* be assigned a value.
     * @see {@link https://enterprisevm.atlassian.net/browse/PB-7055}
     */

    return (
      <CompositeCalloutComponent>
        <div className="type--bute saving__summary">
          {interest} <br /> {interestInformation}
        </div>
      </CompositeCalloutComponent>
    );
  }

  return null;
};
